
import { defineComponent } from "vue";

import gorgonsGrimoiresLogo from "@/assets/gorgons-grimoires-logo.jpg";
import dystopianDawnLogo from "@/assets/dystopian-dawn-logo.webp";

interface FellowIndie {
  name: string;
  url: string;
  image?: string;
  // Set true for logos drawn as dark/transparent line-art that need a
  // light backing to be legible (otherwise they sit on the dark card).
  light?: boolean;
}

export default defineComponent({
  name: "SocialsIntegration",
  mounted() {
    if (localStorage.getItem("cookiesAccepted") === "true") {
      this.cookiesAccepted = true;
    }
    const checkCookies = setInterval(() => {
      if (localStorage.getItem("cookiesAccepted") === "true") {
        this.cookiesAccepted = true;
        clearInterval(checkCookies);
      }
    }, 250);
  },
  data() {
    return {
      cookiesAccepted: false,
      // To add a creator: import their image at the top of this file
      // (e.g. import theirLogo from "@/assets/their-logo.png") and add an
      // entry here: { name: "Their Name", url: "https://...", image: theirLogo }.
      // Leave `image` off to show a placeholder tile.
      fellowIndies: [
        {
          name: "Gorgon's Grimoires",
          url: "https://gorgonsgrimoire.com/",
          image: gorgonsGrimoiresLogo,
        },
        {
          name: "Dystopian Dawn",
          url: "https://www.fracturedbrainstudios.com/",
          image: dystopianDawnLogo,
          light: true,
        },
      ] as FellowIndie[],
    };
  },
  methods: {
    accepted() {
      localStorage.setItem("cookiesAccepted", "true");
      if (document.getElementById("cookies-base") !== null)
        document.getElementById("cookies-base")!.style.display = "none";
    },
  },
});
